import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=b1358602&scoped=true&"
var script = {}
import style0 from "./Legal.vue?vue&type=style&index=0&id=b1358602&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1358602",
  null
  
)

export default component.exports